import MessageShow from 'FF/Vue/Common/MessageShow/MessageShow.vue';

export default class Message {

    private text: string = '';
    // Vue?: Vue;
    constructor() {
        // this.Vue = new Vue( MessageShow );

        if( Json.messageShow )
        {
            this.show(
                Json.messageShow.text,
                Json.messageShow.second
            );
        }
    }

    downloadUrl( url: string ) {
        var $a = document.createElement('a');
        $a.setAttribute("href", url);
        $a.setAttribute("download", "");
        var evObj = document.createEvent('MouseEvents');
        evObj.initMouseEvent( 'click', true, true, window, 0, 0, 0, 0, 0, false, false, true, false, 0, null);
        $a.dispatchEvent(evObj);
    }

    async show(arg: any, second?: number, url?: string, script?: string) {
        let text: string;
        let downloadUrl: string = '';
        // eslint-disable-next-line no-param-reassign
        second = second && second >= 2 ? second : 2;
        text = arg;
        if (typeof arg === 'object') {
            text = arg.text;
            // eslint-disable-next-line no-param-reassign
            second = arg?.second ?? 2; // 確保second有值
            // eslint-disable-next-line no-param-reassign
            script = arg.script;
            downloadUrl = arg.downloadUrl;
            // eslint-disable-next-line no-param-reassign
            url = arg.url ?? undefined;
        }

        this.text = text;
        const animateTime = (second ?? 2) * 1000 - 300;

        if (downloadUrl) { this.downloadUrl(downloadUrl);}

        let $message = $('[ff-message-show]');

        if ($message.length == 0) {
            const $messageShowClone = $('[ff-message-show-clone]')
                .clone().removeAttr('ff-message-show-clone')
                .attr('ff-message-show', 'true')
                .css('display', 'block')
                .prependTo('body');
        }
        $message = $('[ff-message-show]'); // 更新 $message 參

        // 更新訊息內容
        $message.find('.message_content').html(text);

        // 延遲 DOM 更新完成後再計算寬度
        await new Promise((resolve) => setTimeout(resolve, 10));
        const width = $message.width() || 0;
        $message.css('margin-left', -(width / 2));

        // 設定通知自動消失
        setTimeout(() => {
            const currentText = this.text;// 確保是當前的通知
            if (text === currentText) {
                $message.animate({ opacity: 0 }, 300, 'swing', () => {
                    // 在這裡的 `this` 指向的是 jQuery 物件
                    $message.remove();
                });
            }
        }, animateTime);

        // 防止重複綁定事件
        $(document).off('click', '[ff-message-show]').on('click', '[ff-message-show]', (event) => {
            $(event.currentTarget).animate({ opacity: 0 }, 300, 'swing',  () => {
                $message.remove();
            });
        });

        // 執行script或重新導向
        if (script && !url) {
            // eslint-disable-next-line no-eval
            eval(script);
        }
        if (url) {
            setTimeout(() => {
                const base = $('base').attr('href');
                // eslint-disable-next-line no-restricted-globals
                location.href = url ? base + url : base;
            }, animateTime);
        }
    }
}
